import { Link } from "react-router-dom";
import { nomeDoPeriodo } from "@nhomi/core";
import { periodosFechados } from "@/data/resumos";
import { dayKey } from "@/data/plates";

/** Os resumos que já fecharam, do mais novo ao mais velho (tela de Recap). */
export function EntradaDosResumos({ cid, startDay }: { cid: string; startDay: string }) {
  const lista = periodosFechados(startDay, dayKey());
  if (!lista.length) return null;
  const ano = new Date().getFullYear();
  return (
    <>
      <div className="section-label left">Resumos</div>
      <div className="resumos-entrada">
        {lista.map((p) => (
          <Link key={p} to={`/c/${cid}/resumo/${p}`}>
            {p.length === 4 ? `Retrospectiva ${p}` : nomeDoPeriodo(p, ano)}
            <small>{p.length === 4 ? "o ano todo" : "resumo do mês"}</small>
          </Link>
        ))}
      </div>
    </>
  );
}

/**
 * No feed, na primeira semana do mês: "o resumo de setembro chegou". O
 * resumo é montado no dia 1º; depois da primeira semana ele mora só no
 * Recap — notícia velha no topo do feed vira paisagem.
 */
export function ChegouOResumo({ cid, startDay }: { cid: string; startDay: string }) {
  const hoje = dayKey();
  if (Number(hoje.slice(8, 10)) > 7) return null;
  const [p] = periodosFechados(startDay, hoje).filter((x) => x.length === 7);
  if (!p) return null;
  const ano = Number(hoje.slice(0, 4));
  const retro = hoje.slice(5, 7) === "01" ? String(ano - 1) : null;
  return (
    <div className="pad">
      <Link className="card resumo-chegou" to={`/c/${cid}/resumo/${retro ?? p}`}>
        <span className="resumo-chegou-emoji">📊</span>
        <span>
          <b>{retro ? `A retrospectiva de ${retro} chegou` : `O resumo de ${nomeDoPeriodo(p, ano)} chegou`}</b>
          <small>O que o grupo comeu, o lugar favorito e o pódio</small>
        </span>
      </Link>
    </div>
  );
}
